import { storyblokEditable } from "@storyblok/react";

function SBEditable({ blok, children, withId, withClass }) {
  if (window.location.search.includes("_storyblok")) {
    return (
      <section
        {...storyblokEditable(blok)}
        id={withId || blok.anchor || null}
        className={withClass || null}
      >
        {children}
      </section>
    );
  }

  return (
    <section id={withId || blok.anchor || null} className={withClass || null}>
      {children}
    </section>
  );
}

export default SBEditable;
